module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAGCAYAAADKfB7nAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAMxJREFUeNp0kDEOgkAQRWeXAB2BBGqh8xgcwdJOSjs9hp16ArWipbPVzs54AqCz3IqsUKx/TDSE4CQv8+dnZjK7ghBJkqRIK+CDU1mWR/oT6M2QFkCBvQVjBnEGGjzBMgiCl1LqNjK8Rdo0TRN3XTe1bTtj8w7WvSYfHEaG2TeO4xiUH1hLiBgn776N0HxaPXK9r7Wmtm1/BmteUPD2QfNkOI3FlRCi6ntSSrLw3gd0jixACnLUV/zBZbgkDMPadd25MYY8z6MoiugtwAByi0Q8OjUPYgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-three/exercise-3/cinetics-line/dots-2.png
// module id = 264
// module chunks = 0